import React from "react";
import { ArrowUpRight, ArrowDownRight, Pause } from "lucide-react";

export default function SignalBadge({ action, confidence, size = "default" }) {
  const cfg = {
    BUY: {
      bg: "bg-[#10B981]",
      text: "text-white",
      Icon: ArrowUpRight,
      label: "BUY",
    },
    SELL: {
      bg: "bg-[#EF4444]",
      text: "text-white",
      Icon: ArrowDownRight,
      label: "SELL",
    },
    NO_TRADE: {
      bg: "bg-neutral-900",
      text: "text-white",
      Icon: Pause,
      label: "NO TRADE",
    },
  };
  const c = cfg[action] || cfg.NO_TRADE;
  const sizeCls = size === "lg"
    ? "px-4 py-2 text-sm"
    : size === "sm" ? "px-2 py-0.5 text-[10px]" : "px-3 py-1 text-xs";

  return (
    <span
      className={`inline-flex items-center gap-1.5 font-bold tracking-wider ${c.bg} ${c.text} ${sizeCls} rounded-full ${confidence != null ? "cursor-help" : ""}`}
      data-testid={`signal-badge-${action.toLowerCase()}`}
      title={confidence != null ? "Pattern confidence — model's read on the technical setup only. Moonbucks Score below rolls this in with macro + catalyst-risk factors." : undefined}
    >
      <c.Icon className={size === "lg" ? "w-4 h-4" : "w-3 h-3"} />
      {c.label}
      {confidence != null && (
        <span className="font-mono-data opacity-90 ml-1">{Math.round(confidence * 100)}%</span>
      )}
    </span>
  );
}
